// @flow
import sortBy from 'lodash/fp/sortBy';
import find from 'lodash/fp/find';

import type {
  Facility, CompanyPlace, Photo, FacilityGroup, Worker
} from '../types';

type Relationships = {
  companyPhotos: Array<Photo>,
  facilityPhotos: Array<Photo>,
  workers: Array<Worker>
};

export const photoSorter = (photo: Photo) => {
  const parts = (photo?.attributes?.photo_url || '/0.jpg').split('/');
  const name = parts[parts.length - 1];

  return name;
};

export const connectIncludedData = (
  facility: Facility,
  included: Array<CompanyPlace | Photo | FacilityGroup>
): Facility => {
  const companyId: string = facility.relationships.facility_group?.data?.id || '';
  const company: FacilityGroup = find(
    (resource: FacilityGroup | Photo | CompanyPlace) => resource.id === companyId,
    included
  );

  const facilityPhotoIds = facility.relationships.photos.data.map(photo => photo.id);
  const companyPhotoIds = company.relationships.photos.data.map(photo => photo.id);

  const relationships: Relationships = included.reduce(
    (acc: Relationships, resource: any) => {
      const { id, type, attributes } = resource;

      if (type === 'photo') {
        if (companyPhotoIds.includes(id)) {
          acc.companyPhotos.push(resource);
        } else if (facilityPhotoIds.includes(id)) {
          acc.facilityPhotos.push(resource);
        }
      } else if (type === 'worker' && attributes?.is_active) {
        acc.workers.push(resource);
      }

      return acc;
    },
    { companyPhotos: [], facilityPhotos: [], workers: [] }
  );

  // Sorting photos by file names extracted from url
  relationships.companyPhotos = sortBy(photoSorter, relationships.companyPhotos);
  relationships.facilityPhotos = sortBy(photoSorter, relationships.facilityPhotos);

  const companyWithPhotos: FacilityGroup = {
    ...company,
    relationships: {
      photos: {
        data: relationships.companyPhotos
      }
    }
  };

  return {
    ...facility,
    relationships: {
      ...facility.relationships,
      photos: {
        data: relationships.facilityPhotos,
        listing_url: relationships.facilityPhotos.find(img => img.attributes.kind === 'listing')
          ?.attributes?.photo_url
      },
      company: { data: companyWithPhotos },
      workers: { data: relationships.workers }
    }
  };
};
